import { render } from "./orderDetails.vue?vue&type=template&id=58433cec&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"

import "./orderDetails.vue?vue&type=style&index=0&id=58433cec&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-58433cec"

export default script